import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  cardContainer: {
    display: 'flex',
    width: '471px',
    padding: '20px 40px 40px 40px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    border: '1px dotted',
  },
  paymentConfirmationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '2px',
    alignSelf: 'stretch',
  },
  cardTitle: {
    color: '#000',
    fontFamily: 'Schnyder S',
    fontSize: '48px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '60px',
  },
  paymentStatus: {
    color: '#000',
    fontFamily: 'GT America',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '36px',
    letterSpacing: ' -0.24px',
  },
  paymentDetailsContainer: {
    color: '#000',
    fontFamily: 'GT America',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: '20px',
    letterSpacing: '-0.08px',
  },
}));

export const CardPaymentSuccess = ({ data, user }) => {
  const { firstName, lastName } = user;
  const { paymentId, amount, paymentMessage } = data;

  const classes = useStyles();
  return (
    <div className={classes.cardContainer}>
      <div className={classes.paymentConfirmationContainer}>
        <Typography variant="h3" className={classes.cardTitle}>
          Thank you, {firstName}
        </Typography>
        <br />
        <br />
        <Typography variant="h2" className={classes.paymentStatus}>
          Payment approved!
        </Typography>
        <br />
        <Typography variant="p" className={classes.paymentStatus}>
          {firstName} {lastName}
        </Typography>
        <br />
        <Typography variant="p" className={classes.paymentDetailsContainer}>
          {paymentId}
        </Typography>
        <Typography variant="p" className={classes.paymentDetailsContainer}>
          {amount}
        </Typography>
        <Typography variant="p" className={classes.paymentDetailsContainer}>
          {paymentMessage}
        </Typography>
        <br />
        <p className={classes.paymentDetailsContainer}>
          You will receive a payment confirmation email shortly.
        </p>
      </div>
    </div>
  );
};
